<template>
  <div>
    <form
      @submit="handleSearch($event)"
    >
      <v-row>
        <v-col sm="6" md="6" lg="4" cols="12" >
          <v-text-field
            v-model="textField"
            label="เลขคำสั่งซื้อ หรือชื่อลูกค้า"
            append-icon="mdi-magnify"
            outlined
            hide-details
            dense
            autocomplete="off"
          ></v-text-field>
        </v-col>

        <v-col sm="6" md="6" lg="4" cols="12">
          <v-dialog
            ref="dialog"
            v-model="modalDate"
            :return-value.sync="dateRange"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                label="วันที่"
                append-icon="mdi-calendar-range"
                readonly
                outlined
                hide-details
                dense
                autocomplete="off"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modalDate = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(dates)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col sm="12" md="12" lg="2" cols="12">

          <v-row>
            <v-col cols="12" class="pt-0">
              <v-btn
                color="warning"
                width="100%"
                class="pa-5"
                depressed
                @click="handleResetData()"
              >
                <v-icon class="mr-5">mdi-refresh</v-icon>
                รีเซ็ต
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col sm="12" md="12" lg="2" cols="12">

          <v-row>
            <v-col cols="12" class="pt-0">
              <v-btn
                color="success"
                width="100%"
                class="pa-5"
                depressed
                type="submit"
              >
                <v-icon class="mr-5">mdi-magnify</v-icon>
                ค้นหา
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import script from '@/views/pages/order/search/Search.script';

export default script;
</script>
